module.exports = __webpack_public_path__ + "img/doc1.194d52dc.svg";